import { render, staticRenderFns } from "./VerDetalleRutaModal.vue?vue&type=template&id=89c11a86&"
import script from "./VerDetalleRutaModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleRutaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('89c11a86', component.options)
    } else {
      api.reload('89c11a86', component.options)
    }
    module.hot.accept("./VerDetalleRutaModal.vue?vue&type=template&id=89c11a86&", function () {
      api.rerender('89c11a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/VerDetalleRutaModal.vue"
export default component.exports